module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/vskel12-70abf4edb510a2ae23c02b48f395d547.jpg";